var $ = require('jquery');

$(function () {

    $(".interests--submit")
            .on("click", function (e) {
                e.preventDefault();
                
                var isValid = true;
                var formNode = $(this).closest("form");
                var formId = formNode.attr("id");
                var itemId = formNode.find("input[name=itemId]");
                var serialized = formNode.serialize();
                var selectedIDs = new Array();

                formNode.find('input:checkbox').each(function () {
                    if ($(this).prop('checked')) {
                        selectedIDs.push($(this).val());
                    }
                });

                formNode.find(".interests__save_exception").hide();

                $.ajax({
                    url: "/api/Sitecore/ProfileManagement/Interests",
                    type: "POST",
                    context: this,
                    contentType: "application/json",
                    data: JSON.stringify({
                        itemId: itemId.val(),
                        selections: selectedIDs
                    }),
                    success: function (data) {
                        if (data) {
                            if (data.dashboardLandingPageUrl != null && data.dashboardLandingPageUrl !== "") {
                                window.location.href = data.dashboardLandingPageUrl;
                            } else {
                                formNode.find(".accordion-content__item").hide();
                                formNode.find(".accordion-content__footer").hide();
                                formNode.find(".accordion-content__footer__dynamic").show();
                            }
                        }
                    },
                    error: function (jqXHR, status, error) {
                        handleError(formNode, jqXHR, status, error);
                    }

                });
            });

    function handleError(formNode, jqXHR, status, error) {
        if(formNode !== undefined)
        {
            formNode.find(".interests__save_exception").show();
        }
    }
})